export default __webpack_public_path__ + "static/media/profilePicture.a24ea39c.webp";